export default __webpack_public_path__ + "static/media/greekgo-screenshot-04.70389cfd.png";